module.exports = __webpack_public_path__ + "img/x-solid.2599abee.svg";